/**
 * Static data source for the Physical Editions collection.
 */

import {
  Ancient_Jericho,
  Bedouin_Woman,
  Dolorosa_Street,
  Fishermen_near_Haifa,
  Fountain_of_the_Virgin,
  Priest_at_the_church_of_all_nations,
  Temple_Mount_Qaytbey_Fountain,
  Tiberias_from_the_Lake,
  VineyardBoyWithGrapes,
  WomanInTraditionalAttire,
  Cover,
} from "../assets";

export const physicalEditionItems = [
  {
    id: 1,
    name: "Woman in Traditional Attire",
    description:
      "This rare postcard captures a woman dressed in traditional clothing, holding a water jug, photographed by Khalil Raad, the renowned Jerusalem-based photographer, during the 1920s. Raad’s work provides an exceptional visual record of Palestinian life, customs, and culture in the early twentieth century. The original photograph is preserved at the Heritage Museum of Darret Khawla and Samir Abu Dehays, while a restored version is maintained in our private collection. To honor this cultural treasure, 50 limited edition copies were produced by Funooni. Each has been meticulously restored and permanently preserved on the blockchain, ensuring this historic image remains safeguarded for future generations.",
    year: 1920,
    sizes: ["A3"],
    price: 200,
    link: "https://buy.stripe.com/28E14maCtbZ7do65l51gt0u",
    exclusivesizes: "A3",
    exclusivePrice: 300,
    exclusiveLink: "https://buy.stripe.com/14A8wOeSJ8MVck2eVF1gt0v",
    images: [
      WomanInTraditionalAttire,
      WomanInTraditionalAttire,
      WomanInTraditionalAttire,
    ],
    prev: WomanInTraditionalAttire,
    availability: "25 items are available",
  },
  {
    id: 2,
    name: "Bedouin Woman",
    description:
      "This rare photographic postcard, Bedouin Woman and dated 1921, was taken by the Jamal Brothers, prominent Palestinian photographers of the early twentieth century. The image captures a Bedouin woman in traditional attire, offering a glimpse into the clothing, customs, and daily life of indigenous Bedouin communities in Palestine during this period. The photograph highlights the cultural diversity of early twentieth-century Palestine, where Bedouin, urban, and rural populations coexisted, each contributing to the region’s rich social fabric. Through its intimate portrayal, the postcard preserves a moment of everyday life and the unique heritage of the Bedouin people. The original postcard is preserved at the Heritage Museum of Darret Khawla and Samir Abu Dehays, while a restored version is held within our private collection. To honor this cultural piece, 50 limited edition copies have been produced by Funooni, each carefully restored and secured on the blockchain, ensuring authenticity and long-term digital access for future generations.",
    year: 1921,
    sizes: ["A3"],
    price: 200,
    link: "https://buy.stripe.com/8x26oG3a1d3b0Bk6p91gt0F",
    exclusivesizes: "A3",
    exclusivePrice: 300,
    exclusiveLink: "https://buy.stripe.com/cNicN4h0R2oxfweaFp1gt0G",
    images: [Bedouin_Woman, Bedouin_Woman, Bedouin_Woman],
    prev: Bedouin_Woman,
    availability: "25 items are available",
  },
  {
    id: 3,
    name: "Vineyard Boy with Grapes",
    description:
      "This rare historical photograph, published in the Palestinian press in October 1943 and restored by Funooni as part of the Cities Collection, and now preserved permanently on the blockchain. Cities such as Hebron, Jaffa, and others were renowned for grape cultivation, one of Palestine’s most important agricultural crops. During the summer harvest season, farmers devoted exceptional care to their vineyards, making grapes a symbol of prosperity, dedication, and a deep connection to the land. The image reflects a time when agriculture formed the backbone of Palestinian society and economy, preserving a powerful visual memory of rural life, heritage, and resilience.",
    year: 1943,
    sizes: ["60x60"],
    price: 800,
    link: "https://pay.ziina.com/funooni/3Tp_nQUw9",
    exclusivesizes: "60x60",
    exclusivePrice: 300,
    exclusiveLink: "https://buy.stripe.com/00w00i11TaV32JsdRB1gt0i",
    images: [
      VineyardBoyWithGrapes,
      VineyardBoyWithGrapes,
      VineyardBoyWithGrapes,
    ],
    prev: VineyardBoyWithGrapes,
    availability: "12 items are available",
  },
  {
    id: 4,
    name: "Tiberias from the Lake",
    description:
      "This rare postcard, Tiberias from the Lake (circa 1910–1920s), photographed by Fadil Saba, captures a timeless view of Tiberias along the shores of the Sea of Galilee. The image highlights the city’s historic waterfront, where stone architecture meets the calm waters, and a lone sailboat reflects the simplicity of daily life and local livelihood. The composition evokes a sense of tranquility and continuity, documenting a moment where nature, architecture, and community coexist in harmony. The original postcard is preserved at the Heritage Museum of Darret Khawla and Samir Abu Dehays, while a restored version is held within our private collection. To honor this cultural piece, 50 limited edition copies have been produced by Funooni, each carefully restored and secured on the blockchain, ensuring authenticity and long-term digital access for future generations.",
    year: 1910,
    sizes: ["A3"],
    price: 200,
    link: "https://buy.stripe.com/3cIfZg9ypaV397Q6p91gt0I",
    images: [
      Tiberias_from_the_Lake,
      Tiberias_from_the_Lake,
      Tiberias_from_the_Lake,
    ],
    prev: Tiberias_from_the_Lake,
    availability: "25 items are available",
  },
  {
    id: 5,
    name: "Temple Mount - Qaytbay Fountain, Jerusalem",
    description:
      "This remarkable photographic postcard captures the elegant Qaytbay Fountain within the sacred precinct of the Temple Mount, photographed by the renowned Lehnert & Landrock studio between 1924 and 1930. The composition presents one of Jerusalem’s most refined examples of late Mamluk architecture, standing prominently against the spiritual and architectural landscape of the Haram al-Sharif. The image highlights the richly ornamented stone structure of the Qaytbay Fountain, commissioned by Sultan al-Ashraf Qaytbay in the late fifteenth century. Celebrated for its intricate carvings, domed canopy, and harmonious proportions, the fountain served both practical and ceremonial purposes, providing water for worshippers while embodying the artistic sophistication of Mamluk Jerusalem. The original postcard is preserved at the Heritage Museum of Darret Khawla and Samir Abu Dehays, while a restored version is held within our private collection. To honor and safeguard this extraordinary visual record, 50 limited edition copies have been meticulously restored and secured on the blockchain by Funooni, ensuring its authenticity, provenance, and long-term digital preservation for future generations.",
    year: 1924,
    sizes: ["A3"],
    price: 200,
    link: "https://buy.stripe.com/aFabJ0aCtd3bdo69Bl1gt0J",
    images: [
      Temple_Mount_Qaytbey_Fountain,
      Temple_Mount_Qaytbey_Fountain,
      Temple_Mount_Qaytbey_Fountain,
    ],
    prev: Temple_Mount_Qaytbey_Fountain,
    availability: "50 items are available",
  },

  {
    id: 6,
    name: "Fountain of the Virgin, Nazareth",
    description:
      "This rare photographic postcard captures Mary’s Well (Fountain of the Virgin) in Nazareth, photographed by A. Attalah Freres in 1910s, among the most renowned photographers of the late nineteenth and early twentieth centuries in the region. The image depicts a group of local women and children gathered around the historic stone archway of the fountain, many carrying traditional ceramic water jars (jars) on their heads, illustrating a daily scene of communal life and the vital importance of this water source. The site holds deep religious significance, revered in Christian tradition, and the architecture shown marks the spot where the spring’s waters were traditionally drawn, serving as a focal point for both local residents and arriving pilgrims for centuries. This archival piece offers an intimate glimpse into the social fabric and traditional attire of Nazareth's inhabitants during this era. The original postcard is preserved at the Heritage Museum of Darret Khawla and Samir Abu Dehays, while a restored version is held within our private collection. To honor this cultural piece, 50 limited edition copies have been produced by Funooni, each carefully restored and secured on the blockchain, ensuring authenticity and long-term digital preservation for future generations.",
    year: 1910,
    sizes: ["A3"],
    price: 200,
    link: "https://buy.stripe.com/aFa28qbGx0gpabU4h11gt0K",
    images: [
      Fountain_of_the_Virgin,
      Fountain_of_the_Virgin,
      Fountain_of_the_Virgin,
    ],
    prev: Fountain_of_the_Virgin,
    availability: "50 items are available",
  },
  {
    id: 7,
    name: "Dolorosa Street, Jerusalem",
    description:
      "This rare photographic postcard captures the Dolorosa street in Jerusalem, photographed by A. Attallah Frères in the 1920s, among the most renowned photographers of the late 1919s and 1920s in the region. The image presents a vivid street scene along the historic route, where local residents and passersby move through the narrow stone street, reflecting the rhythm of daily life within the Old City. This archival piece offers a valuable glimpse into the urban life, architecture, and atmosphere of early twentieth-century Jerusalem. The original postcard is preserved at the Heritage Museum of Darret Khawla and Samir Abu Dehays, while a restored version is held within our private collection. To honor and safeguard this remarkable historical artifact, 50 limited edition copies have been meticulously restored and secured on the blockchain by Funooni, ensuring its authenticity, provenance, and long-term digital preservation for future generations.",
    year: 1920,
    sizes: ["A3"],
    price: 200,
    link: "https://buy.stripe.com/bJe00idOFe7fdo6bJt1gt0L",
    images: [Dolorosa_Street, Dolorosa_Street, Dolorosa_Street],
    prev: Dolorosa_Street,
    availability: "50 items are available",
  },
  {
    id: 8,
    name: "Fishermen near Haifa",
    description:
      "This striking postcard, Fishermen near Haifa, captured in 1932 by the American Colony (Jerusalem), documents a vivid scene of communal fishing along the Mediterranean coast near Haifa. The image portrays a group of fishermen working together to haul in a large net brimming with freshly caught fish, their coordinated efforts reflecting the collective nature of traditional coastal labor. Rich in detail, the photograph reveals the craftsmanship of handmade fishing nets, the traditional attire of the fishermen, and the dynamic interaction between people, sea, and livelihood. It captures not only the physical demands of fishing but also the spirit of cooperation and resilience that sustained coastal communities for generations. The abundance of the catch and the energy of the scene speak to the Mediterranean’s vital role as a source of sustenance, commerce, and cultural identity. The original postcard is preserved at the Heritage Museum of Darret Khawla and Samir Abu Dehays, while a restored version is held within our private collection. To honor this cultural piece, 50 limited edition copies have been produced by Funooni, each carefully restored and secured on the blockchain, ensuring authenticity and long-term digital preservation for future generations.",
    year: 1932,
    sizes: ["A3"],
    price: 200,
    link: "https://buy.stripe.com/bJe3cucKB8MV3Nw7td1gt0M",
    images: [Fishermen_near_Haifa, Fishermen_near_Haifa, Fishermen_near_Haifa],
    prev: Fishermen_near_Haifa,
    availability: "50 items are available",
  },
  {
    id: 9,
    name: "Priest at the church of all nations, Gethsemane",
    description:
      "This rare postcard captures a priest at the church of all nations, Gethsemane, in front of Al-Aqsa Mosque in Jerusalem in 1930, documented by the photographers Albina Brothers. The image reflects the spiritual atmosphere and architectural beauty of one of the city’s most sacred sites, highlighting its historical and cultural significance. Through their lens, the Albina Brothers preserved a unique moment within the sanctuary, where daily life and devotion intersect. The presence of the monk within the compound offers a glimpse into the diverse religious landscape of Jerusalem during the early twentieth century, illustrating the city’s layered identity and shared sacred spaces. The original postcard is preserved at the Heritage Museum of Darret Khawla and Samir Abu Dehays, while a restored version is maintained in our private collection. To honor this cultural treasure, 50 limited edition copies were produced by Funooni. Each has been meticulously restored and permanently preserved on the blockchain, ensuring this historic image remains safeguarded for future generations.",
    year: 1920,
    sizes: ["A3"],
    price: 200,
    link: "https://buy.stripe.com/eVqfZgbGx4wF6ZI5l51gt0B",
    images: [
      Priest_at_the_church_of_all_nations,
      Priest_at_the_church_of_all_nations,
      Priest_at_the_church_of_all_nations,
    ],
    prev: Priest_at_the_church_of_all_nations,
    availability: "25 items are available",
  },
  {
    id: 10,
    name: "Ancient Jericho",
    description:
      "This remarkable photograph, Ancient Jericho Fountain with Mount of Temptation, captured in the 1950s by G. Semerdjian, offers a serene and evocative view of Jericho, one of the oldest continuously inhabited cities in the world. The scene centers on one of Jericho’s historic irrigation channels, likely fed by the renowned Spring of Elisha, whose waters have sustained the city’s fertile oasis for millennia. Dominating the background is the imposing Mount of Temptation, its rugged limestone slopes rising dramatically above the oasis. The striking contrast between the verdant palm groves below and the arid desert mountains beyond captures the unique character of Jericho, a place where water, faith, and human settlement have intertwined for thousands of years. The original photograph is preserved at the Heritage Museum of Darret Khawla and Samir Abu Dehays, while a restored version is held within our private collection. To honor and safeguard this extraordinary visual record, 50 limited edition copies have been meticulously restored and secured on the blockchain by Funooni, ensuring its authenticity, provenance, and long-term digital preservation for future generations.",
    year: 1950,
    sizes: ["A3"],
    price: 200,
    link: "https://buy.stripe.com/5kQ6oGfWN0gpbfYeVF1gt0N",
    images: [Ancient_Jericho, Ancient_Jericho, Ancient_Jericho],
    prev: Ancient_Jericho,
    availability: "50 items are available",
  },
];

export const physicalEditionCollection = {
  title: "Physical Editions",
  subtitle: "Preserving Art. Connecting Stories.",
  tags: [`${physicalEditionItems.length} items`, "Physical Purchase"],
  description: `The Physical Editions feature curated artworks by renowned and emerging artists across the region, spanning fine art, contemporary art, photography, digital art, and NFT-based works. Each piece is transformed into a limited-edition collectible with museum-quality production and Funooni’s blockchain-backed Certificate of Authenticity, preserving its story, authenticity, provenance, and long-term value.`,
  ctaLabel: "View Collection",
  coverImage: [Cover],
  supportText: "support@funoonarab.com",
  article: {
    sectionLabel: "Physical Editions Story",
    title: "A Diverse Collection of Regional Art",
    sections: [
      {
        subtitle: "Expressions of Art & heritage",
        paragraphs: [
          "The Physical Editions Collection brings together carefully curated works by renowned and emerging Palestinian and Arab artists, celebrating diverse forms of artistic expression across generations. Featuring fine art, contemporary art, photography, digital art, and NFT-based artworks, the collection highlights the creativity, identity, and cultural narratives of the region.",
          "Featuring artists such as Ghazi Inaim, Ahed Izhiman, and Mahmoud Bushnaq, alongside other influential creators, each artwork reflects unique perspectives, personal journeys, and historical moments. From Palestinian identity and heritage to contemporary interpretations of society, these works represent more than visual creations—they are stories preserved through artistic expression.",
        ],
      },
      {
        subtitle: "Transforming Art into Authenticated Collectibles",
        paragraphs: [
          "Funooni preserves and enhances these artworks through professional digitization, restoration, and museum-quality production while maintaining the original character and artistic vision of each piece. Each artwork is transformed into a limited-edition physical collectible, allowing collectors to own a meaningful connection to the artist, the artwork, and the cultural story behind it.",
          "Every edition is accompanied by a Certificate of Authenticity (COA), unique serial number, holographic smart QR code, and blockchain verification, creating a trusted link between the physical artwork and its digital record. Through this combination of art and technology, Funooni ensures transparent provenance, protects artists’ legacies, and preserves cultural stories for future generations.",
        ],
      },
    ],
  },

  exclusives: {
    title: "Drop Exclusives",
    subtitle: "3 one-of-a-kind works available only in this monthly drop",
    images: [Bedouin_Woman, VineyardBoyWithGrapes, WomanInTraditionalAttire],
    description:
      "Every month, from the 8 new releases in the drop, we carefully select 3 outstanding works to be offered as exclusive prints. These pieces are printed on fine art paper, larger than the standard editions and are available framed only.",
  },
  products: physicalEditionItems,
};

export default physicalEditionCollection;
